/**
 * Shared constants for D3 chart styling across cascade bidding visualizations.
 * Ensures consistent margins, spacing, and axis styling.
 */

// ============================================
// Chart Margins
// ============================================

/** Standard margin for charts */
export const CHART_MARGIN = {
  top: 20,
  right: 20,
  bottom: 80,
  left: 70,
} as const

// ============================================
// Axis Label Positioning
// ============================================

/** Y-axis label offset from axis (negative = left of chart) */
export const Y_AXIS_LABEL_OFFSET = -50

/** X-axis label offset from axis (positive = below chart) */
export const X_AXIS_LABEL_OFFSET = 45

/** Tick padding for axis labels */
export const AXIS_TICK_PADDING = 12

// ============================================
// Axis Styling
// ============================================

/** Axis line color */
export const AXIS_LINE_COLOR = '#9ca3af'

/** Axis domain stroke width */
export const AXIS_STROKE_WIDTH = 0.5

/** Axis text color (primary) */
export const AXIS_TEXT_COLOR_PRIMARY = '#374151'

/** Axis text color (secondary) */
export const AXIS_TEXT_COLOR_SECONDARY = '#6b7280'

/** Axis label font size */
export const AXIS_LABEL_FONT_SIZE = '12px'

/** Axis label font weight */
export const AXIS_LABEL_FONT_WEIGHT = 400

/** Axis label letter spacing */
export const AXIS_LABEL_LETTER_SPACING = '0.03em'
